import React from 'react';
import './privacy.css'

const Privacy = () => {
    return (
        <div className="privacy-container">
            <p className="center-text">
                <b>ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ ТА ЗАХИСТУ ПЕРСОНАЛЬНИХ ДАНИХ</b>
            </p>

            <p className="justify-text">
                <br/>
                Ця Політика конфіденційності регулює реалізацію практики збору інформації з ФОП Яковлєв Євгеній Юрійович
                (далі - "ми" або "нас"). Зокрема, він визначає типи інформації, яку ми збираємо за час, коли ви
                використовуєте наш веб-сайт: rent.pixelgame.com.ua (далі - "Сайт"), а також методи використання зібраної
                інформації з нашої частини.
            </p>

            <p className="justify-text">
                Ми просимо вас ретельно ознайомитись із реальною політикою конфіденційності. Відвідавши та
                використовуючи Сайт, ви погоджуєтесь з тим, що використання Сайту вас та будь-яких суперечок та
                розбіжностей щодо конфіденційності, регулюються цією Політикою конфіденційності.
            </p>

            <br/>

            <p className="justify-text">
                <b>Як ми збираємо інформацію</b>
            </p>

            <p className="justify-text">
                Ми можемо збирати, зберігати та обробляти особисту та іншу інформацію, надану вами, за допомогою нашого
                Сайту. Наприклад, Ми можемо зв’язатися з особами, які подали заявку на послуги, а також осіб, які
                зв’язалися з нами, надаючи свою інформацію, щоб отримати відповідь на свої запитання.
            </p>

            <p className="justify-text">
                Ми збираємо від наших користувачів персональну ідентифікаційну інформацію через сторінки Сайту та час
                від часу можуть з’явитися інші сторінки, які збирають подібну інформацію. Загалом, ця інформація включає
                повне ім’я, номера телефону, адреси електронної пошти та паролі, щоб зареєструватися або вибрати
                послуги.
            </p>

            <p className="justify-text">
                Крім того, ми збираємо та зберігаємо інформацію, яка генерується в автоматичному режимі, коли ви
                переходите через сайт в Інтернеті. Наприклад, ми можемо зібрати інформацію про підключення вашого
                комп’ютера до Інтернету, яка, серед іншого, дозволить нам покращити доступ до наших веб-сторінок для вас
                та вимірювати трафік на сайті. Сайт також може автоматично визначати та зберегти інформацію про тип
                браузера, який ви використовуєте; Ваша адреса протоколу підключення до Інтернету ("IP-адреса"); час,
                дата та тривалість візиту; а також сайт візиту. Ми також використовуємо стандартну функцію програмного
                забезпечення для браузера під назвою "Cookie" для покращення вашого досвіду від відвідування Сайту.
                Файли cookie - це невеликі файли, які ваш веб-браузер зберігає на жорсткому диску вашого комп'ютера, щоб
                підтримувати документацію. Показуючи, як і коли користувачі користуються Сайтом, файли cookie
                допомагають нам визначити, скільки унікальних користувачів відвідують наш Сайт, відстежують їх тенденції
                та схеми та можуть допомогти у проведенні рекламних кампаній або доставці інших сповіщень. Вони також
                можуть звільнити вас від необхідності переоцінки ваших уподобань у певних областях сайту, де ви вже
                ввели свої уподобання щодо інформації раніше. Файли cookie можна зберігати, поки ви не видалите їх
                вручну або не встановите відмову, щоб зберегти їх у своєму браузері. У разі відмови прийняти файли
                cookie, у вас можуть виникнути труднощі навігації на веб-сайті, або показники ефективності можуть
                відрізнятися. Сайт також може використовувати веб-маяки (елементарний графічний файл, також відомий як
                "прозорий файл GIF") для доступу до файлів cookie та розгляду користувачів, які відвідують сайт або
                відкривають електронні повідомлення у форматі HTML.
            </p>

            <p className="justify-text">
                Ми можемо використовувати інформацію, зібрану від вас, у той час, коли ви використовуєте Сайт, різними
                способами, включаючи використання інформації для налаштування функцій або реклами, які можуть
                відображатися на сайті. Ми також можемо надати вашу інформацію третім сторонам як процесорам даних або
                іншим постачальникам послуг або рекламодавцям, щоб покращити якість вашого досвіду взаємодії з нами, із
                Сайтом, або надати вам інформацію про відповідні товари та послуги.
            </p>

            <p className="justify-text">
                Якщо ви не хочете, щоб ваша інформація була використана для будь-якої з наведених вище цілей, напишіть
                електронне повідомлення на пошту: pixelgameua@gmail.com та вкажіть цілі, в яких ви хочете заборонити
                використовувати свою інформацію. Ми просимо вас дати нам розумний проміжок часу, щоб видалити вашу
                інформацію з цих цілей, і з огляду на це припинення використання інформації для цих цілей не може бути
                негайним.
            </p>

            <p className="justify-text">
                Більше того, Ми можемо розкрити вашу інформацію, за шкалою, необхідною законодавством, або за шкалою, в
                якій ми вважаємо за необхідне захистити наші юридичні інтереси. Ми залишаємо за собою право
                співпрацювати з державними органами та розкривати таку інформацію, щоб відповідати вимогам юридичного
                процесу.
            </p>

            <br/>

            <p className="justify-text">
                <b>Використання інструментів аналізу Google</b>
            </p>

            <p className="justify-text">
                Ми також можемо скористатися функціональністю рекламодавця інструментів аналізу Google (або подібних
                служб) для оптимізації його діяльності.
            </p>

            <p className="justify-text">
                Функціональність рекламодавця включає:
            </p>

            <p className="justify-text">
                Повторне маркетинг за допомогою інструментів аналізу Google;<br/>
                Повідомлення про враження від контекстної медичної мережі Google;<br/>
                Інтеграція з платформою DoubleClick (двічі клацання); Та<br/>
                Демографічна звітність та звітність інтересу інструментів аналізу Google.
            </p>

            <p className="justify-text">
                Після включення функцій інструментів Google Analytics нам потрібно повідомити відвідувачів, розкриваючи
                інформацію про використання цих функцій та про те, що ми та файли cookie третіх сторін (наприклад,
                інструменти аналізу Google) або інші основні ідентифікатори, а також файли cookie третіх сторін
                (наприклад, файли cookie DoubleClick) або інші ідентифікатори третіх сторін збиратимуть дані про вашу
                діяльність на нашому Сайті. Серед інших методів використання, це дозволяє нам зв’язатися з вами, якщо ви
                почнете заповнювати нашу тестову форму, але перестаньте робити це в процесі заповнення. Цей контакт
                можна здійснити за допомогою електронного повідомлення з нагадуванням про завершення заповнення вашого
                замовлення. Функція повторного маркетингу дозволяє нам зв’язатися з особами, які раніше відвідували наш
                веб-сайт, та порівняти правильну аудиторію з правильним рекламним повідомленням. Ви можете відмовитися
                від використання файлів cookie компанією Google, відвідавши налаштування реклами Google, та/або ви
                можете відмовитися від використання файлів cookie третіми сторонами, відвідавши сторінку відмови Network
                Advertising Initiative.
            </p>

            <br/>

            <p className="justify-text">
                <b>Розташування вашої інформації</b>
            </p>

            <p className="justify-text">
                Ваші особисті дані можуть бути оброблені нами в Україні відповідно до вимог чинного законодавства.
                Погоджуючись з політикою цієї конфіденційності, ви даєте однозначну та безумовну згоду на збір та
                обробку будь-якої особистої та неособистісної інформації, яка була зібрана або отримана від нас на
                міжнародному рівні.
            </p>

            <br/>

            <p className="justify-text">
                <b>Зберігання вашої інформації</b>
            </p>

            <p className="justify-text">
                Ваша інформація буде зберігатися на серверах ФОП Яковлєв Євгеній Юрійович, що забезпечує збереження
                наших даних, а обмін повідомленнями буде зберігатися до тих пір, поки ця інформація не буде корисною,
                більше не буде. Ваша інформація буде доступна лише для нас та тих компаній, які надають допомогу в
                управлінні Сайтом.
            </p>


            <br/>


            <p className="justify-text">
                <b>Електронний маркетинг та відхилення від нього</b>
            </p>

            <p className="justify-text">
                Наскільки це вимагається Законом про боротьбу з агресивною несанкціонованою порнографією та рекламою
                2003 року (Закон CAN-SPAM) або іншими подібними внутрішніми міжнародними нормативними актами, усі
                комерційні електронні листи, надіслані вам нами, міститимуть посилання для скасування підписки. Ви
                можете видалити себе з нашого списку розсилки в будь-який час, натиснувши посилання для скасування
                підписки в кожному повідомленні, яке ми вам надсилаємо.
            </p>


            <br/>


            <p className="justify-text">
                <b>Ваші права на конфіденційність</b>
            </p>

            <p>
                Ви маєте право на доступ, транспортування, оновлення, виправлення чи видалення своїх особистих даних, а
                також право оскаржити або обмежити їх використання або скасувати їх використання. Ці права можна
                реалізувати, надіславши електронний лист на адресу: pixelgameua@gmail.com. Ви також маєте право подати
                скаргу до місцевих органів із захисту даних, якщо ви думаєте, що ваші права на конфіденційність даних
                щодо вашої особистої інформації не дотримуються належним чином.
            </p>

            <p className="justify-text">
                У вашому повідомленні, надісланому нам, ви повинні включити достатню кількість інформації, щоб ми
                знайшли ваш особистий файл, включаючи принаймні ваше повне ім’я, номер телефону, електронну адресу та
                поштову адресу.
            </p>

            <p className="justify-text">
                Ми спробуємо надати вам необхідну інформацію протягом тридцяти (30) днів після отримання. Ми залишаємо
                за собою право не відповідати на запити, надіслані більше одного разу протягом одного календарного року,
                або на запити інформації, відмінної від зазначеної в цьому повідомленні.
            </p>

            <br/>

            <p className="justify-text">
                <b>Оновлення Політики конфіденційності</b>
            </p>

            <p className="justify-text">
                Ми залишаємо за собою право оновлювати цю Політику про конфіденційність на власний розсуд. Актуальна
                версія Політики конфіденційності розташована у вільному доступі в мережі Інтернет за адресою:
                https://rent.pixelgame.com.ua/privacy/. Використання нашого вебсайту з вашого боку означає вашу згоду з
                умовами Політики конфіденційності, відповідно до наших змін та доповнень, і з цієї причини, вам слід
                регулярно переглядати цю Політику конфіденційності для забезпечення того, що ви знаєте умови цієї
                політики.
            </p>

            <p className="justify-text">
                У разі виникнення питань щодо політики конфіденційності просимо надіслати повідомлення електронної пошти
                на адресу pixelgameua@gmail.com.
            </p>
        </div>
    );
};

export default Privacy;